import { useAxios } from "@/context/axiosContext"
import { useAppDispatch, useAppSelector } from "@/redux/hooks";
import { ComCode, setComCodeList, setComMsgList, setTimestamp } from "@/redux/slices/redisSlice";

export const useRedis = () => {
    const axios = useAxios();
    const dispatch = useAppDispatch();
    const { comCodeList, comMsgList } = useAppSelector((state)=>state.redis);
    const { comCodeLastUpdate, comMsgLastUpdate } = useAppSelector((state)=>state.redis);

    const getComCodes = (key:string) => {
        return comCodeList[key] || [];
    }

    const getComCodeValue = (key:string, value:string) => {
        return comCodeList[key] ? comCodeList[key].find(code => code.code === value) : undefined;
    }

    const refreshComCodes = async () => {
        // TODO 마지막 업데이트 시간 비교, axios 호출 
        const response:any = await axios.post('/redis/getComCodeList', {});
        if(response.status == 200){
            // TODO 성공코드 변경필요 
            dispatch(setComCodeList(response.data.data.list));
        }
    }

    const getComMsgs = (msgCd:string) => {
        return comMsgList[msgCd] || {};
    }

    const refreshComMsgs = async () => {
        // TODO 마지막 업데이트 시간 비교, axios 호출 
        const response:any = await axios.post('/redis/getMsgList', {});
        if(response.status == 200){
            // TODO 성공코드 변경필요 
            dispatch(setComMsgList(response.data.data.list));
        }
    }

    const getTimestamp = async () => {
        const response:any = await axios.post('/redis/getTimestamp', {}, {_disableLoading: true,});
        if(response.status == 200){
            const newComCodeLastUpdate = response.data.data.timestamp?.COM_CODE;
            const newComMsgLastUpdate = response.data.data.timestamp?.COM_MSG_MASTER;
            if(newComCodeLastUpdate != comCodeLastUpdate){
                // 공통코드 재호출
                refreshComCodes();
            }
            if(newComMsgLastUpdate != comMsgLastUpdate){
                // 메세지 재호출
                refreshComMsgs();
            }
            // 시간값 업데이트 
            dispatch(setTimestamp(response.data.data.timestamp));
        }
    }

    return {refreshComCodes, getComCodes, getComCodeValue, getComMsgs, refreshComMsgs, getTimestamp};
}